import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import LogoImage from '../../app/assets/Logo.png'

const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  z-index: 1000;
`

const Image = styled.img`
  height: 40px;
  width: auto;
`

const LogoIcon: React.FC = () => {
  return (
    <LogoContainer to="/">
      <Image src={LogoImage} alt="Logo" />
    </LogoContainer>
  )
}

export default LogoIcon
